import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCriticalOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M9.99 7.798a.646.646 0 0 0-.635.654v2.968a.647.647 0 1 0 1.29 0V8.452a.645.645 0 0 0-.655-.654m.01 5.17a.646.646 0 1 0 0 1.291.646.646 0 0 0 0-1.29Z" />
    <path
      fillRule="evenodd"
      d="M8.229 3.589c.783-1.371 2.76-1.371 3.543 0l5.776 10.108c.777 1.36-.205 3.053-1.771 3.053H4.223c-1.566 0-2.548-1.692-1.771-3.053zm2.24.744a.54.54 0 0 0-.938 0L3.754 14.442a.54.54 0 0 0 .47.808h11.553a.54.54 0 0 0 .469-.808z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCriticalOutline;
